export default defineNuxtRouteMiddleware((next) => {
  const cookie = localStorage.getItem('food-pantry-token');
  const sessionStore = useSessionStore();

  if (cookie === undefined || cookie === null || !sessionStore.timerActive) {
    // @ts-ignore
    return (window.location = `/eds/${next.params?.id}`);
  }
});
